import { ButtonHTMLAttributes, ReactNode } from "react";
import styles from "./Button.module.scss";

type IconPosition = "left" | "right";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  iconPosition?: IconPosition;
  children?: ReactNode;
}

export default function Button({
  icon,
  iconPosition = "left",
  children,
  className,
  ...props
}: ButtonProps) {
  return (
    <button className={`${styles.button} ${className ?? ""}`} {...props}>
      {icon && iconPosition === "left" && <span className={styles.icon}>{icon}</span>}

      {children && <span className={styles.label}>{children}</span>}

      {icon && iconPosition === "right" && <span className={styles.icon}>{icon}</span>}
    </button>
  );
}
